import React from 'react';
import styles from './EmptyPlayerCross.module.css';

const EmptyPlayerCross = () => {
    return (
        <div className={styles.crossContainer}>
            <div className={styles.crossLine1}></div>
            <div className={styles.crossLine2}></div>
        </div>
    );
};

export default EmptyPlayerCross;
